import PaginationDropdown from './Dropdown';

export default PaginationDropdown;
export { PaginationDropdown };
